import { useEffect, useState } from 'react'
import { defineQuery } from 'groq'
import { getClient } from '../client'
import { useLang } from '../i18n/LocaleProvider'
import { useLiveVersion } from './useLiveVersion'
import type { HELP_QUERY_RESULT } from '../sanity.types'

const HELP_QUERY = defineQuery(`*[_id == "singleton-helpPage"][0] {
  "contact": { office, email, phone, address },
  "faq": faqItems[]-> {
    _id, question, answer,
    "translation": *[_type == "translation.metadata" && references(^._id)][0].translations[_key == $lang][0].value-> {
      _id, question, answer
    }
  }
}`)

type HelpPage = NonNullable<HELP_QUERY_RESULT>
type FaqEntry = NonNullable<HelpPage['faq']>[number]

export type HelpContent = {
  contact: HelpPage['contact']
  faq: Array<Omit<FaqEntry, 'translation'>>
}

export function useHelpContent() {
  const [content, setContent] = useState<HelpContent | null>(null)
  const lang = useLang()

  const live = useLiveVersion()

  useEffect(() => {
    let active = true
    getClient()
      .fetch(HELP_QUERY, { lang })
      .then((result) => {
        if (!result) return null
        const faq = (result.faq ?? []).map(({ translation, ...item }) => translation ?? item)
        return { contact: result.contact, faq }
      })
      .then((result) => active && setContent(result))

    return () => {
      active = false
    }
  }, [lang, live])

  return content
}
